import React from 'react';
import { MapPin } from 'lucide-react';
export function FarmingtonDistance() {
  return <section className="bg-charcoal text-white py-6" data-id="element-1277">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-center gap-3" data-id="element-1278">
        <MapPin className="w-6 h-6 text-storm-red" data-id="element-1279" />
        <span className="text-lg font-bold uppercase tracking-wide" data-id="element-1280">
          Right next door to downtown Farmington
        </span>
      </div>
    </section>;
}